import { SVGProps } from "react"

export function EditIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.997 15.919" {...props}>
      <path fill="currentColor" d="M9.947 2.657L13.201 5.911 4.964 14.148 1.712 10.894 9.947 2.657" />
      <path
        fill="currentColor"
        d="M15.671 1.872L14.219.421a1.439 1.439 0 00-2.034 0L10.8 1.811l3.254 3.254 1.622-1.622a1.109 1.109 0 00-.005-1.571zM.009 15.468a.37.37 0 00.448.44l3.626-.879-3.252-3.254z"
      />
    </svg>
  )
}
